import listPageBaseConfigMixin from './list-page-base-config-mixin';
import {convertQueryParams, handleError} from '../../util/componentUtil';
import {Notification} from 'element-ui';
export default {
  mixins: [listPageBaseConfigMixin],
  methods: {
    addListListener() {
      const listPage = this.getListPage();
      // 保证只会做一次添加监听的动作
      if (!listPage || this.addListListenerFlag) {
        return;
      }
      this.addListListenerFlag = true;
      listPage.$on('size-change', this.handleSizeChange);
      listPage.$on('page-current-change', this.handlePageCurrentChange);
      if (!listPage.$listeners['tab-click']) {
        listPage.$on('tab-click', this.handleTabClick);
      }
      const xTable = listPage.getXTable();
      if (!xTable) {
        return;
      }
      if (!listPage.$listeners['sort-change']) {
        xTable.$on('sort-change', this.handleSortChange);
      }
      if (!listPage.$listeners['filter-change']) {
        xTable.$on('filter-change', this.handleFilterChange);
      }
    },
    removeListListener() {
      const listPage = this.getListPage();
      if (!listPage) {
        return;
      }
      this.addListListenerFlag = false;
      listPage.$off('size-change', this.handleSizeChange);
      listPage.$on('page-current-change', this.handlePageCurrentChange);
      if (!listPage.$listeners['tab-click']) {
        listPage.$off('tab-click', this.handleTabClick);
      }
      const xTable = listPage.getXTable();
      if (!xTable) {
        return;
      }
      if (!listPage.$listeners['sort-change']) {
        xTable.$off('sort-change', this.handleSortChange);
      }
      if (!listPage.$listeners['filter-change']) {
        xTable.$off('filter-change', this.handleFilterChange);
      }
    },
    async loadData ({validate = true} = {}) {
      const listPage = this.getListPage();
      if (listPage.hasDataAttribute) {
        return;
      }
      if (!this.api) {
        return;
      }
      try {
        const queryParams = await this.getQueryParams({validate});
        const res = await this.api(queryParams);
        if (!res.isSuccess()) {
          if (res.msg) {
            Notification.error(res.msg);
          }
          listPage.loadData([]);
          return;
        }
        const data = res.data;
        if (this.handleResult) {
          this.handleResult({listPage, data});
        } else {
          listPage.setSummary(data.summary);
          listPage.setTotal(data.totalRows);
          listPage.loadData(data.list);
        }
      } catch (error) {
        handleError(error);
      }
    },
    /**
     * 获取查询参数
     * @param validate 是否校验必填项，默认true
     * @return {Promise<unknown>}
     */
    async getQueryParams ({validate = true} = {}) {
      const listPage = this.getListPage();
      const queryParams = Object.assign({}, this.queryParams);
      const tabConfig = listPage.tabConfig;
      if (listPage.realPageConfig.show) {
        Object.assign(queryParams, {pageSize: listPage.getPageSize(), page: listPage.getCurrentPage()});
      }
      const sortList = listPage.realSortConfig.remote ? listPage.getXTable().getSortList() : null;
      // 如果父组件传入转换器，就使用父组件传入的转换器，否者使用内部的转换器
      if (this.queryParamsConverter) {
        this.queryParamsConverter({
          filterList: this.filterList,
          conditionConfig: this.conditionConfig,
          tabConfig,
          queryParams: queryParams,
          sortList
        });
      } else {
        convertQueryParams({
          filterList: this.filterList,
          conditionConfig: this.conditionConfig,
          tabConfig,
          queryParams: queryParams,
          sortList
        });
      }
      // 增加queryParams处理的回调
      if (this.handleQueryParams) {
        await this.handleQueryParams({queryParams});
      }
      if (!validate) {
        return Promise.resolve(queryParams);
      }
      // 校验参数
      if (this.validateQueryParams) {
        return this.validateQueryParams(queryParams).then(() => {
          return Promise.resolve(queryParams);
        });
      } else {
        return this.getListPage().validate().then(() => {
          return Promise.resolve(queryParams);
        });
      }
    },
    handleSortChange() {
      const listPage = this.getListPage();
      if (listPage.realSortConfig.remote === false) {
        return;
      }
      this.reLoadData();
    },
    handleFilterChange(args) {
      this.filterList = args.filterList;
      this.reLoadData();
    },
    handleTabClick(tabPane) {
      // 这里做一个延时查询，让父组件可以先进行一些逻辑处理
      setTimeout(() => {
        this.reLoadData();
      }, this.tabConfig.delay || 0);
    },
    /**
     * 处理列表数据被删除后的页码变动
     */
    handleRecordRemove() {
      // 计算总页码
      const listPage = this.getListPage();
      const xTable = listPage.getXTable();
      const data = xTable.getGridInstance().getTableData().fullData;
      const rows = xTable.getRecords();
      const totalPageNum = Math.ceil(listPage.getTotal() / listPage.getPageSize());
      const currentPage = listPage.getCurrentPage();
      // 如果不是最后一页的数据，就直接重新加载
      if (currentPage !== totalPageNum) {
        this.loadData();
        return;
      }
      // 直接删除数据有问题
      // vxe-grid有可能通过loadData方法来记载数据，直接操作外部出入的data不会触发重新渲染，因此重新查询会比较合理
      // 如果删除的数据量和当前表格数据量不一样或者当前页是第一页，就直接加载当前页
      if (rows.length !== data.length || currentPage === 1) {
        this.loadData();
        return;
      }
      // 如果是最后一页且删除的数据量和表格中是数据量一样，需要加载上一页的数据
      listPage.setCurrentPage(currentPage - 1);
      this.loadData();
    }
  }
};
